import React from 'react';

// CSS
import './menu-hero.css';

const MenuHero = ({ restaurant }) => {
  return (
    <section className="menu-hero">
      <div className="menu-hero-container">
        <h1 className="menu-hero-headline">
          {restaurant ? restaurant.name : "Explore Our Mouth-Watering Menu"}
        </h1>
        <h2 className="menu-hero-subheadline">
          {restaurant?.description ||
            "Homemade meals, prepared with love & delivered fresh to your doorstep"}
        </h2>
      </div>
    </section>
  );
};

export default MenuHero;
